module.exports = __webpack_public_path__ + "static/img/yuanquan.cb065e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/element/yuanquan.png
// module id = rSn7
// module chunks = 6